import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl'
import CustomSelect from '../../others/customSelect.component.jsx';

const messages = defineMessages({
    "isNotOneOf": {
        id: "common.search_filter.operation.isNotOneOf",
        defaultMessage: "is not one of",
    },
    "isOneOf": {
        id: "common.search_filter.operation.isOneOf",
        defaultMessage: 'is one of',
    },
})

class CustomSelectFilter extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            operation: props.op || "isOneOf",
            value: props.value || [],
            options: props.options,
        }

        this.onChangeSelectFilter = this.onChangeSelectFilter.bind(this);
        this.onChangeSelectOp = this.onChangeSelectOp.bind(this);

    }

    onChangeSelectFilter(value, labels) {
        this.setState({ value: value })

        if ((Array.isArray(value) && value.length < 1) || value === "") {
            this.props.onChangeValues("remove", this.props.id, "")
        } else {
            this.props.onChangeValues("add", this.props.id, value, labels, this.state.operation)
        }

    }

    onChangeSelectOp(event) {
        let aux = event.target.value.split("-")
        this.setState({ value: "", operation: aux[1] })
        this.props.onChangeValues("remove", this.props.id, "")
    }


    render() {
        return (
            <div className="panel panel-default card">
                <select
                    className="form-control mb-2"
                    name="operation-select"
                    value={this.props.id + "-" + this.state.operation}
                    onChange={this.onChangeSelectOp}
                    id={this.props.id + "-op"}
                >
                    <option value={this.props.id + "-isOneOf"}>{this.props.intl.formatMessage(messages["isOneOf"])}</option>
                    <option value={this.props.id + "-isNotOneOf"}>{this.props.intl.formatMessage(messages["isNotOneOf"])}</option>
                </select>

                <CustomSelect
                    multi={true}
                    name={this.props.filterElement.labelName}
                    placeholder={this.props.placeHolder}
                    value={this.state.value}
                    options={this.props.options}
                    onChange={this.onChangeSelectFilter}
                />
            </div>

        );
    }
}
export default injectIntl(CustomSelectFilter);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/types/customSelectFilter.component.jsx